export const enUS = {
	name: 'English',
	common: {
		publish: "发布",
		operation: "Operation",
		backToList: "Back to List",
		submit: "Submit",
		enabled: "Enabled",
		disable: "Disable",
		open: "On",
		close: "Off",
		yes: "yes",
		no: "no",
		quickCreate: "Quick create",
		delete: "Delete",
		revoke: "Revoke",
		adjust: "Adjust",
		approve: "Approve",
		reject: "Reject",
		pass: "Pass",
		pleaseInput: "Please input ",
		pleaseSelect: "Please select ",
		pleaseUpload: "Please upload ",
		query: "Query",
		reset: "Reset",
		create: "Create",
		modify: "Modify",
		detail: "Detail",
		save: "Save",
		view: "View",
		confirm: "Confirm",
		cancel: "Cancel",
		nullify: "Nullify",
		please: "Please",
		download: "Download",
		upload: "Upload",
		description: "Description",
		deleteItem: "Are you sure to delete this item?",
		deleteItems: "Are you sure to delete this selected item?",
		deleteSuccess: "Successfully deleted!",
		nullifyItem: "Are you sure to nullify this item?",
		nullifySuccess: "Nullify deleted!",
		isSubmit: "是否确认提交？",
		isPublish: "是否确认发布？",
		isApprove: "是否确认审核通过？",
		isReject: "是否确认拒绝？",
		batchOperation: "Batch operation",
		enabledSuccess: "Enabled successfully",
		disableSuccess: "Disable successfully",
		createSuccess: "Created successfully!",
		synchronizeSuccess: "Synchronize successfully!",
		approveSuccess: "Approve successfully!",
		modifySuccess: "Modification successfully!",
		operateSuccess: "Operate successfully",
		all: "All",
		sync: "Sync",
		fiscalYear: "Fiscal Year",
		previous: "Previous",
		next: "Next",
		useTips: "Use tips",
		allow: "Allow",
		forbidden: "Forbidden",
		draft: "Draft",
		saveDraft: "Save as draft",
		send: "Send",
		inReview: "In Review",
		approved: "Approved",
		rejected: "Rejected",
		status: "Status",
		recall: "Recall",
		attachment: "Attachment",
		submited: "Submited",
		selectAll: "Select All",
		batchDelete: "Batch Delete",
		rmb: "RMB",
		rejectReason: "Reject Reason",
		collapse: "Collapse",
		expand: "Expand",
		downloadTemplate: "下载模板",
		uploadData: "上传数据",
		batchUpload: "批量上传数据",
		unit: "Unit",
		export: "Export",
		exportData: "Export data",
		import: "Import",
		importData: "Import data",
		uploadSuccess: "Upload successfully",
		apply: "Apply",
		day: "Days",
		refresh: "刷新",
		refreshSuccess: "Refresh successfully!",
		sort: "Sort"
	},
	component: {
		header: {
			loginOut: "Login Out",
			toggleZh: "中文",
			toggleEn: "English",
			cnZH: "Simplified Chinese",
			cnTW: "Traditional Chinese",
			enUS: "English"
		},
		footer: {
			copyright: "Powered by USDT国际信用卡管理系统"
		},
		editForm: {
			inputPlaceholder: "Please input ",
			selectPlaceholder: "Please select "
		},
		table: {
			total: "Total",
			items: "items"
		}
	},
	login: {
		title: "USDT国际信用卡管理系统",
		loginBtn: "登录",
		copyright: "USDT国际信用卡管理系统提供技术支持",
		rememberAccount: "记住账号"
	},
	tableColumns: {
		operation: "Operation",
		code: "Code",
		fullName: "Full name",
		isEnable: "Enable",
		name: "Name",
		updatedAt: "更新时间",
		regIp: "注册ip",
		lastIp: "最后一次登陆ip",
		lastTime: "最后一次登陆时间",
		CreatedAtString: "创建时间",
		UpdatedAtString: "修改时间",
	},
	page: {
		home: {
			name: 'Overview',
		},
		mine: {
			name: "个人中心",
			refresh: "是否刷新邀请码？"
		},
		amount: {
			name: "金额管理",
			auditAt: "审核时间",
			auditManagerId: "审核管理员id",
			commissionFee: "手续费",
			status: "状态",
			status1: "审核中",
			status2: "拒绝",
			status3: "取消",
			status4: "完成",
			remark: "审核备注",
			email: "用户邮箱",
			memberId: "用户Id",
			receivedAmount: "实际到账金额",
			CheckResult: "审核结果",
			CheckResult1: "通过",
			CheckResult2: "驳回",
			walletType: "货币类型",
			walletType1: "usd",
			recharge: {
				name: "充值管理",
				amount: "支付金额",
				managerId: "业务员id",
				memberUsdtAddress: "用户充值地址",
				orderSn: "关联订单号",
				payCallbackStatus: "支付状态",
				payCallbackStatus1: "待审核",
				payCallbackStatus2: "通过",
				randomMantissa: "随机尾数",
				rechargeType: "支付类型",
				rechargeType1: "银行转账",
				rechargeUsdtAddress: "充值到账地址",
				RechargeId: "充值订单id",
				rechargeStatus: "充值状态",
				rechargeStatus1: "待支付",
				rechargeStatus2: "充值中",
				rechargeStatus3: "失败",
				rechargeStatus4: "取消",
				rechargeStatus5: "完成",
			},
			withdrawal: {
				name: "提现管理",
				orderNo: "订单号",
				amount: "提现金额",
				bankId: "提现银行卡id"
			},
			balanceLog: {
				name: "余额日志",
				after: "变更后",
				amount: "变更金额",
				before: "变更前",
				daily: "日期",
				describe: "描述",
				scene: "变动场景",
				track: "出入标识",
				track1: "增加",
				track2: "减少",
				transactionId: "交易id",
				transactionNo: "交易编号",
			}
		},
		card: {
			name: "卡片管理",
			udpayCardBin: "卡bin（卡头）",
			udpayCardScheme: "卡scheme",
			udpayModeType: "卡模式",
			udpayProductId: "平台产品id",
			udpayProductStatus: "订单状态",
			memberId: '用户id',
			main: {
				udpayCardStatus: '卡状态',
				cardProductId: '卡产品id',
				udpayCardCurrency: "币种",
				udpayAvailableBalance: "可用余额",
				member: "用户"
			},
			product: {
				name: "卡产品管理",
				status1: "有效",
				status2: "无效",
				async: "同步",
			},
			record: {
				email: "邮箱",
				name: "卡片充提记录",
				fullName: "卡片充值提现记录列表",
				cardId: "卡id",
				amount: "金额",
				commissionFee: "手续费",
				orderNo: "订单号",
				receivedAmount: "实际到账",
				type: "类型",
				udpayCardId: "卡id",
				udpayCardOrderId: "卡订单id",
				udpayOrderStatus: "订单状态",
				udpayOrderType: "订单类型",
				walletType: "货币类型",
				memberCardId: "用户卡id",
				type1: "充值",
				type2: "提现",
			},
			transaction: {
				name: "卡账单（交易记录）",
				authorizationCode: "授权码",
				billingAmount: "账单金额",
				billingCurrency: "计费货币",
				cardAvailableBalance: "卡可用余额",
				failureReason: "失败的原因",
				postedTime: "交易过账时间",
				transactionAmount: "交易金额",
				transactionCurrency: "交易货币",
				transactionFee: "交易费用",
				transactionStatus: "交易状态",
				transactionTime: "交易发生时间",
				transactionType: "交易类型",
				transactionType1: "因卡使用而预留的资金",
				transactionType2: "购买金额退还至账户余额",
				transactionType3: "撤销授权",
				udpayCardId: "卡片Id",
				udpayTransactionId: "交易Id",
				udpayCardholderId: "持卡人Id",
				udpayMaskedCardNumber: "卡号",
				udpayOriginalTransactionId: "原交易Id",
			}
		},
		level: {
			name: "等级管理",
			cardNum: "卡位",
			cardNumTip: "最大在线卡数量，已删除不计入",
			cycle: "会员时长",
			cycleTip: "基数天",
			introduction: "简介",
			level: "等级",
			minRechargeAmount: "最小充值金额",
			title: "名称",
			openCardFee: "开卡费",
			price: "价格",
			serviceRate: "卡服务费率",
			usdRechargeRate: "美金充值费率",
			usdtRechargeRate: "usdt充值费率",
			withdrawRate: "	提现手续费率",
		},
		member: {
			name: "人员管理",
			user: {
				name: "用户管理",
				user: "用户",
				account: "账号",
				agentId: "代理id",
				amount: "默认货币余额",
				amount1: "余额",
				commission: "佣金",
				commissionAll: "累计佣金",
				createdAt: "创建时间",
				email: "邮箱",
				freezeAmount: "冻结金额",
				fundPasswordHash: "资金密码",
				isCanTrade: "是否可交易",
				lastIp: "最后一次登陆ip",
				lastTime: "最后一次登陆时间",
				lever: "杠杆id",
				managerId: "推广业务员id",
				regIp: "代理id",
				type: "用户类型",
				type1: "普通用户",
				type2: "模拟用户",
				updateAmount: "上下分",
				addAmount: "上分",
				reduceAmount: "下分",
				usdAmount: "美元金额",
				FundPassword: "资金密码",
				Password: "密码",
				now: "当前余额",
				after: "之后余额",
				grade: "会员等级",
			},
			manager: {
				name: "管理员管理",
				avatar: "头像",
				inviteCode: "邀请码",
				pid: "上级",
				role: "角色",
				role1: "普通管理员",
				role2: "超级管理员",
				username: "帐号",
				password: "密码",
				manager: "管理员",
				pwd: "更新密码"
			},
			role: {
				name: "角色管理",
				id: "角色Id",
				roleName: "角色名称"
			}
		},
		settings: {
			name: "设置",
			notice: {
				notice: "公告设置",
				config: "配置管理",
				privilege: "权限管理",
				system: "系统管理",
				noticeName: "公告名称",
				IsPop: "是否弹窗",
				display: "显示",
				hidden: "隐藏",
				sort: "排序",
				language: "语言",
				noticeId: "公告id",
				title: "标题",
				noticeS: "公告",
				viewNotice: "查看公告",
				noticeTitle: "公告标题"
			},
			config: {
				name: "配置管理",
				config: "配置",
				cateId: "配置分类",
				mark: "配置标识",
				remark: "配置说明",
				sort: "排序",
				title: "配置标题",
				type: "配置类型",
				value: "配置值",
			},
			privilege: {
				name: "权限设置"
			},
			system: {
				name: "系统设置"
			}
		},
	}
};
